import { defineComponent as _defineComponent } from 'vue'
import { computed, useStore } from "@nuxtjs/composition-api";

import { useAmplitude } from "@/composables";
import { getProfilesStore } from "@/store/profiles"; // TODO - replace after store refactor
import { heroImageCreatorShop, heroImageOnly } from "@/utils/services/LtkItemHeightCalculator";


export default /*#__PURE__*/_defineComponent({
  __name: 'PostFeed',
  props: {
  displayName: { type: String, required: true },
  ltkIds: { type: Array, required: true, default: () => [] },
  showLoading: { type: Boolean, required: true, default: false },
  showError: { type: Boolean, required: true, default: false },
  isVisible: { type: Boolean, default: false }, // used to force layout calculation(s)
  isSearch: { type: Boolean, default: false },
},
  emits: ["page", "retry"],
  setup(__props, { emit: emits }: { emit: ({
  (e: "page"): void;
  (e: "retry"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;




const store = useStore();
const amplitude = useAmplitude();
const fetchState = computed(() => {
  const pending = props.showLoading;
  const error = props.showError;
  return { pending, error };
});

const profileId = computed(() => getProfilesStore(store).getIdByDisplayName(props.displayName) || "");
const itemHeightFunction = computed(() => {
  if (props.isSearch) {
    return heroImageCreatorShop;
  }
  return heroImageOnly;
});

const onPaging = () => {
  amplitude?.sendScrollEvent("/scroll/publisher", props.ltkIds?.length);
  emits("page");
};
const onRetry = () => {
  emits("retry");
};

return { __sfc: true,props, emits, store, amplitude, fetchState, profileId, itemHeightFunction, onPaging, onRetry }
}

})